function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 7.5,
  cy: 7.5,
  r: 6.75,
  stroke: "#CBCACA",
  strokeWidth: 1.5
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.82992 10.5466C8.30808 11.3844 6.88929 11.7379 6.23621 11.1573C5.97157 10.922 5.79121 10.4301 5.81187 10.0687C5.85569 9.2982 6.04685 8.53477 6.19442 7.77182C6.40575 6.67903 6.41212 6.68035 5.35715 6.14962C5.62707 6.07385 5.79121 5.99352 5.95812 5.98752C6.45726 5.96963 6.95749 5.97563 7.45724 5.98212C8.12521 5.99076 8.25681 6.15574 8.13386 6.83272C7.97008 7.7352 7.79837 8.63623 7.63183 9.53811C7.60661 9.67511 7.57911 9.81344 7.57227 9.95212C7.53661 10.6715 7.79753 10.8672 8.46706 10.6341C8.569 10.5987 8.67779 10.5826 8.82992 10.5466Z",
  fill: "#CBCACA"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.40429 4.34168C8.39228 4.90327 7.95401 5.3078 7.38462 5.28306C6.81547 5.25833 6.44576 4.84503 6.46161 4.25091C6.47638 3.69761 6.87382 3.31986 7.42556 3.33475C7.96674 3.34951 8.41569 3.8112 8.40429 4.34168Z",
  fill: "#CBCACA"
});

function SvgIconAbout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAbout);
export default __webpack_public_path__ + "static/media/iconAbout.0e72c3c6.svg";
export { ForwardRef as ReactComponent };